import { render, staticRenderFns } from "./newGroup.vue?vue&type=template&id=a4a3e864&scoped=true"
import script from "./newGroup.vue?vue&type=script&lang=js"
export * from "./newGroup.vue?vue&type=script&lang=js"
import style0 from "./newGroup.scss?vue&type=style&index=0&id=a4a3e864&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a3e864",
  null
  
)

export default component.exports